export const PlantDesignRefData = {
  itemLocationTypeOptions: '6073_picklistvalues',
  registrationStateOptions: '6007_picklistvalues',
  otherSubTypeValue: 'Other (please describe)',

  plantTypes: {
    name: 'plant_itemtype',
    pickListValueName: 'tangibletypecode',
  },

  boiler: {
    hazardLevelOptions: '6014_picklistvalues',
    outputUnitOptions: '6026_picklistvalues',
    attendanceOptions: '6027_picklistvalues',
    otherBoilerType: 'Other (please describe)',
  },
  pressureVessel: {
    numberOfChambersOptions: '6010_picklistvalues',
    hazardLevelOptions: '6014_picklistvalues',
  },
  gasCylinder: {
    materialTypeOptions: '6150_picklistvalues',
    constructionTypeOptions: '6152_picklistvalues',
    testPressureUnitOptions: '6155_picklistvalues',
    contentsOptions: '6156_picklistvalues',
    otherMaterialType: 'Other (please describe)',
  },
  lift: {
    locationTypeOptions: '6046_picklistvalues',
    suspensionTypeOptions: '6035_picklistvalues',
    carriageTypeOptions: '6037_picklistvalues',
    controlTypeOptions: '6038_picklistvalues',
  },
  hoistWithPlatformMovement: {
    hoistTypeOptions: '6140_picklistvalues',
    otherHoistType: 'Other (please describe)',
  },
  vehicleHoist: {
    driveTypeOptions: '6113_picklistvalues',
  },
  mastClimbingWorkPlatform: {
    mastTypeOptions: '6161_picklistvalues',
    baseTypeOptions: '6162_picklistvalues',
  },
  boomTypeElevatingWorkPlatform: {
    designUsesOptions: '6176_picklistvalues',
    insulationTypeOptions: '6174_picklistvalues',
  },
  bridgeCrane: {
    craneControlTypeOptions: '6104_picklistvalues',
  },
  gantryCrane: {
    craneControlTypeOptions: '6104_picklistvalues',
  },
  prefabricatedScaffolding: {
    maxPlatformDutyRatingOptions: '6189_picklistvalues',
    materialOptions: '6150_picklistvalues',
    otherMaterial: 'Other (please describe)',
    towerFrameType: 'Tower Frame',
    frameType: 'Frame',
    modularType: 'Modular',
  },
  concretePlacingBoom: {
    mobileOrTruckMountedTypeValue: 'Mobile/ Truck- mounted',
  },
  amusementDevice: {
    deviceClassOptions: '6048_picklistvalues',
    mobilityTypeOptions: '6072_picklistvalues',
    operatingPowerOptions: '6052_picklistvalues',
    intrinsicSafetyOptions: '6054_picklistvalues',
    otherOperatingPower: 'Other (please describe)',
  },
  passengerRopeway: {
    passengerRopeTypeOptions: '6125_picklistvalues',
    carrierTypeOptions: '6126_picklistvalues',
  },

  plantRefs: {
    boiler: {
      key: 'boiler',
      code: '100',
      name: 'boiler',
      subTypeRef: {
        optionsKey: '6022_picklistvalues',
        otherSubTypeValue: 'Other (please describe)',
      },
      helpText: {
        title:
          'You must design register boilers categorised as hazard level A, B, C or D. See section 2.1 of AS 4343: 2014.',
        paragraphs: [],
        listItems: ['Do not design register heritage boilers.'],
      },
    },
    pressureVessel: {
      key: 'pressureVessel',
      code: '101',
      name: 'pressure vessel',
      subTypeRef: {
        optionsKey: '6011_picklistvalues',
        otherSubTypeValue: 'Other',
      },
      helpText: {
        title:
          'You must design register pressure vessels categorised as hazard level A, B, C or D. See section 2.1 of AS 4343: 2014.',
        paragraphs: [],
        listItems: [
          'Do not design register pressure equipment (other than a gas cylinder) excluded from the scope of AS/NZS 1200:2000 (Pressure equipment).',
        ],
      },
    },
    gasCylinder: {
      key: 'gasCylinder',
      code: '102',
      name: 'gas cylinder',
      helpText: {
        title: 'You must design register gas cylinders covered by Section 1.1 of AS 2030.1-2009.',
        paragraphs: [],
        listItems: [],
      },
    },
    lift: {
      key: 'lift',
      code: '103',
      name: 'lift',
      subTypeRef: {
        optionsKey: '6033_picklistvalues',
        otherSubTypeValue: 'Other (please describe)',
      },
    },
    escalator: {
      key: 'escalator',
      code: '104',
      name: 'escalator',
    },
    movingWalkway: {
      key: 'movingWalkway',
      code: '105',
      name: 'moving walkway',
    },
    hoistWithPlatformMovement: {
      key: 'hoistWithPlatformMovement',
      code: '106',
      name: 'hoist with platform movement',
      helpText: {
        title:
          'You must design register hoists with a platform movement exceeding 2.4 metres, designed to lift people.',
        paragraphs: [],
        listItems: ['Do not design register hoists that are manually powered.'],
      },
    },
    vehicleHoist: {
      key: 'vehicleHoist',
      code: '107',
      name: 'vehicle hoist',
      subTypeRef: {
        optionsKey: '6111_picklistvalues',
        otherSubTypeValue: 'Other (please describe)',
      },
      helpText: {
        title: 'Do not design register hoists that are manually powered.',
        paragraphs: [],
        listItems: [],
      },
    },
    mastClimbingWorkPlatform: {
      key: 'mastClimbingWorkPlatform',
      code: '108',
      name: 'mast climbing work platform',
      subTypeRef: {
        otherSubTypeValue: 'Other (please describe)',
      },
      helpText: {
        title: 'Do not design register manually powered work platforms.',
        paragraphs: [],
        listItems: [],
      },
    },
    buildingMaintenanceUnit: {
      key: 'buildingMaintenanceUnit',
      code: '109',
      name: 'building maintenance unit',
      helpText: {
        title: 'Do not design register building maintenance units that are manually powered.',
        paragraphs: [],
        listItems: [],
      },
    },
    boomTypeElevatingWorkPlatform: {
      key: 'boomTypeElevatingWorkPlatform',
      code: '110',
      name: 'boom type elevating work platform',
      subTypeRef: {
        optionsKey: '6170_picklistvalues',
        otherSubTypeValue: 'Other (please describe)',
      },
      helpText: {
        title: 'Do not design register a:',
        paragraphs: [],
        listItems: ['reach stacker', 'elevating work platform that is scissor lift or a vertically moving platform. '],
      },
    },
    towerCrane: {
      key: 'towerCrane',
      code: '111',
      name: 'tower crane',
      subTypeRef: {
        optionsKey: '6065_picklistvalues',
      },
      helpText: {
        title: 'You must design register tower cranes, including self-erecting tower cranes, except for:',
        paragraphs: [],
        listItems: ['cranes that are manually powered.'],
      },
    },
    mobileCrane: {
      key: 'mobileCrane',
      code: '112',
      name: 'mobile crane',
      subTypeRef: {
        optionsKey: '6069_picklistvalues',
        otherSubTypeValue: 'Other (please describe)',
      },
      helpText: {
        title: 'You must design register mobile cranes with a rated capacity of more than 10 tonnes, except for:',
        paragraphs: [],
        listItems: ['cranes that are manually powered.'],
      },
    },
    bridgeCrane: {
      key: 'bridgeCrane',
      code: '114',
      name: 'bridge crane',
      subTypeRef: {
        optionsKey: '6103_picklistvalues',
        otherSubTypeValue: 'Other (please describe)',
      },
      helpText: {
        title:
          'You must design register bridge cranes with a safe working load greater than 10 tonnes & bridge cranes which are designed to handle molten metal or Schedule 11 hazardous chemicals, except for:',
        paragraphs: [],
        listItems: ['cranes that are manually powered.'],
      },
    },
    gantryCrane: {
      key: 'gantryCrane',
      code: '115',
      name: 'gantry crane',
      subTypeRef: {
        optionsKey: '6095_picklistvalues',
        otherSubTypeValue: 'Other (please describe)',
      },
      helpText: {
        title:
          'You must design register gantry cranes with a safe working load greater than 5 tonnes & gantry cranes which are designed to handle molten metal or Schedule 11 hazardous chemicals, except for:',
        paragraphs: [],
        listItems: ['cranes that are manually powered.'],
      },
    },
    suspendedWorkbox: {
      key: 'suspendedWorkbox',
      code: '116',
      name: 'suspended workbox',
      helpText: {
        title: 'You must design register work boxes designed to be suspended from cranes.',
        paragraphs: [],
        listItems: [],
      },
    },
    prefabricatedScaffolding: {
      key: 'prefabricatedScaffolding',
      code: '117',
      name: 'prefabricated scaffolding',
      subTypeRef: {
        optionsKey: '6188_picklistvalues',
        otherSubTypeValue: 'Other (please describe)',
      },
    },
    concretePlacingBoom: {
      key: 'concretePlacingBoom',
      code: '118',
      name: 'concrete placing boom',
      subTypeRef: {
        optionsKey: '6079_picklistvalues',
        satelliteOrFixed: 'Satellite/ Fixed',
        mobileOrTruckMounted: 'Mobile/ Truck- mounted',
      },
    },
    amusementDevice: {
      key: 'amusementDevice',
      code: '119',
      name: 'amusement device',
      subTypeRef: {
        optionsKey: '6049_picklistvalues',
        otherSubTypeValue: 'Other (Please describe)',
      },
      helpText: {
        title:
          'You must design register amusement devices classified by section 2.1 of AS 3533.1-2009 (see exceptions).',
        paragraphs: ['Do not register:'],
        listItems: [
          'class 1 devices',
          'playground devices',
          'water slides where water facilitates patrons slide easily (predominantly under gravity) along a static structure',
          'wave generators where patrons do not come into contact with the parts of machinery used for generating water waves',
          'inflatable devices that are not continuously blown or inflatable devices with platforms less than three meters in height.',
        ],
      },
    },
    passengerRopeway: {
      key: 'passengerRopeway',
      code: '120',
      name: 'passenger ropeway',
      subTypeRef: {
        optionsKey: '6125_picklistvalues',
        otherSubTypeValue: 'Other (please describe)',
      },
    },
  },
};

// Find index from the selected option.
export const getDescriptionFromPickList = (refData, selectedOption) => {
  if (!refData || !selectedOption) return null;

  // Check if the option consists of two numbers separeted by '_'. E.g. 6150_1
  const regex = new RegExp('^[0-9]{1,}_[0-9]{1,}$');
  if (!regex.test(selectedOption)) {
    console.error('Invalid argument - ', selectedOption);
    return null;
  }

  const splittedCode = selectedOption.split('_');
  const pickListName = `${splittedCode[0]}_picklistvalues`;
  const optionNumber = parseInt(splittedCode[1]);
  const optionRef = refData[pickListName][optionNumber - 1];

  if (!optionRef?.description) {
    console.error('Could not find the description.', selectedOption, optionRef);
    return null;
  }

  return optionRef.description;
};

export const findPlantRefByPlantTypeCode = (code) => {
  for (const key in PlantDesignRefData.plantRefs) {
    const obj = PlantDesignRefData.plantRefs[key];
    if (obj.code === code) return obj;
  }
};
